<a
  class="atmos-node"
  [class.is-unlocked]="unlocked()"
  [class.is-highlighted]="highlight()"
  [class.is-empty]="!node().item"
  [attr.data-position]="position()"
  [attr.data-action]="action()"
  [attr.aria-pressed]="node().item ? unlocked() : null"
  [attr.href]="href()"
  [attr.aria-label]="node().item?.name ?? null"
  [skyTooltip]="showTooltips() ? node().item?.name : null"
  (click)="onClick($event)">
  @if (node().item; as item) {
    <app-item-icon
      class="atmos-node__icon"
      [item]="item"
      [node]="node()"
      [opaque]="opaque() || unlocked()"
      [subIcons]="subIcons()"
      size="default"></app-item-icon>
  } @else {
    <span class="atmos-node__placeholder"></span>
  }

  @if (cost(); as c) {
    <span class="atmos-node__cost" [attr.data-kind]="c.kind">
      <mat-icon [svgIcon]="c.icon" [class]="'atmos-node__cost-icon ' + c.kind"></mat-icon>
      <strong>{{ c.amount }}</strong>
    </span>
  }

  <!-- Connector arrows toward linked neighbours (tier trees only). -->
  @if (drawConnectors()) {
    @if (node().n) { <span class="atmos-node__arrow atmos-node__arrow--up" aria-hidden="true"></span> }
    @if (node().nw) { <span class="atmos-node__arrow atmos-node__arrow--left" aria-hidden="true"></span> }
    @if (node().ne) { <span class="atmos-node__arrow atmos-node__arrow--right" aria-hidden="true"></span> }
  }

  @if (overlayTemplate(); as tpl) {
    <span class="atmos-node__overlay">
      <ng-container [ngTemplateOutlet]="tpl" [ngTemplateOutletContext]="{ $implicit: node() }"></ng-container>
    </span>
  }
</a>
